import BaseCell from '@tcs/client-portal-common/components/molecules/Table/cells/BaseCell';
import formatDate from '@tcs/common/utils/formatDate';

interface CellProps {
  value: string;
  error?: boolean;
  isPrivate?: boolean;
}

const DateCell = ({ value, error, isPrivate = false }: CellProps) => {
  return (
    <BaseCell
      value={value ? formatDate(value) : '—'}
      error={error}
      isPrivate={isPrivate}
    />
  );
};

export default DateCell;
